import type { SVGProps } from 'react';
const SvgTent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.522 4.15c.288-.2.668-.2.96 0l7.728 5.334c.474.327.78.844.84 1.413l.939 8.931a1.97 1.97 0 0 1-1.959 2.176H4.967a1.97 1.97 0 0 1-1.955-2.176l.939-8.93c.06-.574.366-1.09.84-1.414zm8.512 16.167a.283.283 0 0 0 .281-.31l-.939-8.93a.28.28 0 0 0-.12-.2l-6.412-4.424v7.37l3.572 6.494zM12.156 6.453l-6.41 4.42a.28.28 0 0 0-.119.2l-.939 8.93a.28.28 0 0 0 .282.31h7.186V6.45z"
    />
  </svg>
);
export default SvgTent;
